export default {
    modalQuickActionVariations: {
        title: 'IA',
        generateWithAi: "Generare con l'IA",
        improveWriting: 'Migliorare la scrittura',
        fixSpelling: "Correggi l'ortografia e la grammatica",
        simplifyWriting: 'Semplificare la scrittura',
        makeLonger: 'Allungare',
        makeShorter: 'Rendere più breve',
        replaceText: 'Sostituisci testo',
        addBelow: 'Aggiungi sotto',
        cancel: 'Annulla',
        selectQuickActionTitle: "Dì all'AI cosa fare dopo...",
        regenerate: 'Rigenerare',
    },
};
